<template>
  <div
    class="hover-hand border rounded p-4 hover:shadow-lg transition duration-150 hover:border-challenge text-gray-900 dark:bg-dark-500 dark:border-dark-400 dark:hover:border-challenge dark:text-dark-text"
    @click="onClick"
  >
    <p class="text-lg">{{ middleCl.id }}</p>
    <p class="text-xs text-gray-600 dark:text-dark-text"> {{ middleCl.numberOfProblems }} problems </p>
    <div class="flex items-center my-2">
      <span class="text-xs mr-2 text-gray-600 dark:text-dark-text"> {{ calc2digit(middleCl.progress) }}% </span>
      <base-progress-bar colorType="CHALLENGE" :num="calc2digit(middleCl.progress)" />
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue'

import BaseProgressBar from './BaseProgressBar.vue'

export default defineComponent({
  components: {
    BaseProgressBar
  },
  props: {
    middleCl: {
      type: Object,
      required: true
    },
    onClick: {
      type: Function,
      required: true
    }
  },
  setup() {
    const calc2digit = (num: number) => {
      return Math.floor((num + 0.005) * 100) / 100
    }

    return {
      calc2digit
    }
  }
})
</script>

<style>
.hover-hand {
  cursor: pointer;
  cursor: hand;
}
</style>
